import { get, post } from '../utils/api';

export default class SecurityDepositInterestService {
  getSecurityDepositInterestRates({ organizationId, propertyId }) {
    return get(`/${organizationId}/${propertyId}/securityDepositInterestRates`);
  }

  updateSecurityDepositInterestRates(
    organizationId: string,
    propertyId: string,
    securityDepositInterestRates,
  ) {
    return post(
      `/${organizationId}/${propertyId}/securityDepositInterestRates`,
      JSON.stringify(securityDepositInterestRates),
    );
  }

  getSecurityDepositAccruedInterest({
    organizationId,
    propertyId,
    householdId,
  }) {
    return get(
      `/${organizationId}/${propertyId}/${householdId}/accruedSecurityDepositInterest`,
    );
  }
}
